import { graphql } from 'gatsby';
import { useIntl } from 'gatsby-plugin-intl';
import PropTypes from 'prop-types';

import Page from '../components/Page';
import HeroBannerHomePage from '../components/HeroBannerHomePage';
import SaveAndEarnHomePage from '../components/SaveAndEarnHomePage';
import LocationModule from '../components/LocationModule';
import FAQInsuranceAccordion from '../components/FAQ/FAQInsuranceAccordion';
import LegalDisclaimer from '../components/LegalDisclaimer';
import HowItWorksProducts from '../components/HowItWorksProducts';
import { WhiteBackground } from '../components/Blog/styles';
import VerticalBannerContent from '../components/VerticalBannerContent';
import RegionLockedContent from '../components/RegionLockedContent';
import { filterContentfulArray } from '../utils/regionLockedContent';
import { useProvince } from '../state/ProvinceProvider';

const IndexPage = ({ data, location }) => {
  const { locale } = useIntl();
  const { activeProvince } = useProvince();

  const { sections } = data.contentfulPage;

  const HowItWorksSection = (() => {
    const regionalSections = [
      sections.find(section => section.contentful_id === '1JCrhGwNN0259wqyO8YVrI'), // How It Works - 35% discount, quote button
      sections.find(section => section.contentful_id === '4t6GlYW3pGjSJyz6IApHn3'), // How It Works - 35% discount, phone number
      sections.find(section => section.contentful_id === '4LuK7sYlnwG0ELqY3zzcaW'), // How It Works - 15% discount, phone number
    ].filter(Boolean);
    try {
      return filterContentfulArray(activeProvince, regionalSections)[0];
    } catch {
      return regionalSections[0];
    }
  })();

  const ldJson = [{
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'PC Insurance',
    alternateName: 'PCI',
    url: location.href,
    logo: `${location.origin}/logo-${locale}.svg`,
    sameAs: [
      'https://www.facebook.com/PCInsurance',
      'https://twitter.com/PCInsuranceCA',
      'https://www.instagram.com/pc.insurance/',
    ],
  }];

  return (
    <Page data={data.contentfulPage} ldJson={ldJson} showBackToTop>
      <WhiteBackground>
        {sections.map(section => {
          const { contentful_id, id, regionLockedContent } = section;
          switch (contentful_id) {
            case 'UkhzngqQWDoHhtgBUJUXz': // Renewal banner 1
            case '1nwdyRM3wHYa9SeNZ9SmzG': // Renewal banner 2
            case '418jTfM48uM3ucp9p0ErQO': // Renewal banner 3
              return (
                <RegionLockedContent
                  key={id}
                  data={regionLockedContent}
                  loadingBehavior="fallback"
                >
                  <HeroBannerHomePage key={section.id} data={section} />
                </RegionLockedContent>
              );
            case '5DNsx8n3ytNwlhhl0e1Fp7':
              return !!HowItWorksSection && (
                <HowItWorksProducts
                  key={section.id}
                  data={section}
                  howItWorksSection={HowItWorksSection}
                />
              );
            case '3ojzfevpn5O7yFgmccuebI': // Save & Earn - Home & product pages - 35% discount
            case 'urhmM0Ruov0s9XzpxpKAe': // Save & Earn  - Motorcycle pages - 25% discount
            case '4LzfbzuMAJW6hgXhnHKIxq': // Save & Earn - Home & product pages - 15% discount
              return (
                <RegionLockedContent
                  key={id}
                  data={regionLockedContent}
                  loadingBehavior="fallback"
                >
                  <SaveAndEarnHomePage key={section.id} data={section} />
                </RegionLockedContent>
              );
            case '3gUzHLJUEmoGDEikZPlUO6':
              return <VerticalBannerContent key={section.id} data={section} />;
            case '3qI4L0CCe8BcharZvYJj2b':
              return <LocationModule key={section.id} data={section} />;
            case '76OcBDxUIvkpbQuMrgC2Qx':
              return <FAQInsuranceAccordion key={section.id} data={section} />;
            case '2vB6DVDP9BtVyhbX02rEUM':
              return <LegalDisclaimer key={section.id} data={section} />;
            default:
              return null;
          }
        })}
      </WhiteBackground>
    </Page>
  );
};

IndexPage.propTypes = {
  data: PropTypes.shape().isRequired,
  location: PropTypes.shape().isRequired,
};

export const query = graphql`
  query Home($locale: String = "en-CA") {
    contentfulPage(
      contentful_id: { eq: "6Fj08G9xbkcBQoPaOEjchE" }
      node_locale: { eq: $locale }
    ) {
      ...Page
      sections {
        ...HeroBanner
        ...ProvidersSection
        ...CombinatorSection
        ...LinkSection
        ...FaqSection
        ...TextSection
      }
    }
  }
`;

export default IndexPage;
